import React from "react";
import BuyPermitsPage from "../../components/Pages/BuyPermitsPage";
import Layout from "./Layout";

const ConnectedBuyPermitsPage = (props) => {
  return (
    <>
      <Layout isPrelogin={false} >
        <BuyPermitsPage />
      </Layout>
    </>
  );
};
export default ConnectedBuyPermitsPage;
